// extracted by mini-css-extract-plugin
module.exports = {"container":"index-module_container_HxE1C","animation-container":"index-module_animation-container_2xPhV"};